import script from "./Instaladores.vue?vue&type=script&setup=true&lang=js"
export * from "./Instaladores.vue?vue&type=script&setup=true&lang=js"

import "./Instaladores.vue?vue&type=style&index=0&id=25e6d128&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25e6d128"]])

export default __exports__